import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { OrganizationGivingAccountEnvelope, SetupOrganizationGivingAccountParams } from './types';

export async function setupOrganizationGivingAccount(
  organizationId: string,
  params: SetupOrganizationGivingAccountParams = {}
) {
  const url = `/web/studio/organizations/${organizationId}/giving-account`;

  const body: Record<string, unknown> = {};

  if (params.country) body.country = params.country;

  const response = await api.executePostRequest<ObjectResponse<OrganizationGivingAccountEnvelope>>(url, body);

  return response.data;
}
